const errmsg = state => {
    return (state && state.errmsg) || ''
}
const exchangeData = state => {
    return state.exchangeData || {}
}
const exStatus = state => {
    return state.exStatus || "exStatusing"
}

export default {
    errmsg,
    exchangeData,
    exStatus,
}